import script from "./circleExam.vue?vue&type=script&setup=true&lang=js"
export * from "./circleExam.vue?vue&type=script&setup=true&lang=js"

import "./circleExam.vue?vue&type=style&index=0&id=669d8d03&scoped=true&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669d8d03"]])

export default __exports__